<div [ngClass]="innerClass">
    <div class="nova__dialog__toolbar">
        <div class="nova__dialog__toolbar__title">
            {{ data.title }}
        </div>
        <div class="nova__dialog__toolbar__controls">
            <button class="nova__button--icon" mat-dialog-close><mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon></button>
        </div>
    </div>
    <div mat-dialog-content class="nova__dialog__content">
        <form [formGroup]="templateNameForm" (ngSubmit)="validateTemplateName()">
            <div class="info-row">
                <label>{{ data.inputLabel }}</label>
                <div class="input-container">
                    <input formControlName="templateName" placeholder="Enter text">
                    <div class="form-errors-container">
                        <div *ngIf="templateNameValidation$ | async" class="form-errors">
                            <span>This template name is already taken, please enter a different name.</span>
                        </div>
                        <div *ngIf="templateNameForm.controls['templateName'].invalid && templateNameForm.controls['templateName'].touched" class="form-errors temp-name">
                            <span>Please enter a template name.</span>
                        </div>
                        <div *ngIf="hasSpaces$ | async" class="form-errors">
                            <span>Template Name cannot have leading or trailing spaces.</span>
                        </div> 
                    </div>
                </div>
            </div>
            <mat-dialog-actions class="nova__dialog__content__actions">
                <button mat-raised-button color="primary" [disabled]="templateNameForm.pristine || !templateNameForm.valid">{{ data.confirmText }}</button>
                <button mat-button mat-raised-button color="default" mat-dialog-close>{{ data.cancelText }}</button>
            </mat-dialog-actions>
        </form>
    </div>
</div>
